import React from 'react'
import { DatePicker, TextFieldDisplayType } from '@deal/components'
import { DateRangePathFlowQuestionDefinition } from '#src/components/Path/Question'
import styles from './styles.css'

interface CustomProps {
  display?: TextFieldDisplayType
}

interface DateRangePathFlowQuestionState {
  selectedStartDate?: Date
  selectedEndDate?: Date
}

class DateRangePathFlowQuestion extends React.PureComponent<
  DateRangePathFlowQuestionDefinition<CustomProps>,
  DateRangePathFlowQuestionState
> {
  constructor(props: DateRangePathFlowQuestionDefinition<CustomProps>) {
    super(props)

    const { question } = props

    this.state = {
      selectedStartDate: question.dateRangeUserInput.startValue
        ? new Date(question.dateRangeUserInput.startValue)
        : undefined,
      selectedEndDate: question.dateRangeUserInput.endValue
        ? new Date(question.dateRangeUserInput.endValue)
        : undefined
    }

    // If neither of these are required, mark the question valid
    if (!question.endRequired && !question.startRequired) {
      this.props.onFieldValidityChanged(true)
    }

    this.handleIsQuestionValid = this.handleIsQuestionValid.bind(this)
    this.handleUpdateValues = this.handleUpdateValues.bind(this)
    this.handleEndDateChange = this.handleEndDateChange.bind(this)
    this.handleStartDateChange = this.handleStartDateChange.bind(this)
  }

  public componentDidMount() {
    const { question } = this.props
    const { startValue, endValue } = question.dateRangeUserInput

    if (startValue || endValue) {
      this.props.onFieldValueChanged({
        startValue,
        endValue
      })
    }

    if (!question.required) {
      this.props.onFieldValidityChanged(true)
    }
  }

  public handleIsQuestionValid() {
    const { question } = this.props
    const { selectedStartDate, selectedEndDate } = this.state

    let isQuestionValid = false

    if (question.endRequired && !question.startRequired) {
      isQuestionValid = selectedEndDate ? true : false
    } else if (!question.endRequired && question.startRequired) {
      isQuestionValid = selectedStartDate ? true : false
    } else if (question.endRequired && question.startRequired) {
      isQuestionValid = selectedStartDate && selectedEndDate ? true : false
    }

    this.props.onFieldValidityChanged(isQuestionValid)
  }

  public handleUpdateValues() {
    const { selectedStartDate, selectedEndDate } = this.state

    this.props.onFieldValueChanged({
      startValue: selectedStartDate,
      endValue: selectedEndDate
    })

    this.handleIsQuestionValid()
  }

  public handleEndDateChange(date: Date) {
    this.setState(
      {
        selectedEndDate: date
      },
      this.handleUpdateValues
    )
  }

  public handleStartDateChange(date: Date) {
    this.setState(
      {
        selectedStartDate: date
      },
      this.handleUpdateValues
    )
  }

  public render() {
    const { selectedStartDate, selectedEndDate } = this.state
    return (
      <>
        <div className={styles.input}>
          <DatePicker
            selectedDay={selectedStartDate}
            label="Start Date"
            dayPickerProps={{ disabledDays: { before: new Date() } }}
            onDayChange={this.handleStartDateChange}
          />
        </div>
        <div className={styles.input}>
          <DatePicker
            selectedDay={selectedEndDate}
            label="End Date"
            dayPickerProps={{
              disabledDays: { before: selectedStartDate ? selectedStartDate : new Date() }
            }}
            onDayChange={this.handleEndDateChange}
          />
        </div>
      </>
    )
  }
}

export default DateRangePathFlowQuestion
